import { Link } from "react-router-dom";
import Seo from "../../components/Seo";

export function getEditorialMetadata(article) {
  const canonical = `https://ateno.co/news/${article.slug}`;
  const image = new URL(article.heroImage, "https://ateno.co").href;
  return {
    canonical,
    image,
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "NewsArticle",
      headline: article.title,
      description: article.metaDescription,
      articleSection: article.tag,
      datePublished: article.createdAt,
      dateModified: article.updatedAt,
      wordCount: article.wordCount,
      inLanguage: "en",
      author: { "@type": "Person", name: article.author, jobTitle: article.authorRole, url: "https://ateno.co/team/sviatoslav-gladyshev" },
      publisher: { "@type": "Organization", name: "Ateno", url: "https://ateno.co", logo: { "@type": "ImageObject", url: "https://ateno.co/favicon.png" } },
      image: { "@type": "ImageObject", url: image, width: article.heroWidth, height: article.heroHeight },
      mainEntityOfPage: canonical,
      isAccessibleForFree: true,
    },
  };
}

export default function EditorialArticle({ article }) {
  const meta = getEditorialMetadata(article);
  return (
    <article className="editorial-article">
      <Seo title={article.metaTitle} description={article.metaDescription} path={`/news/${article.slug}`} image={meta.image} type="article" jsonLd={meta.jsonLd} />
      <header className="editorial-header editorial-column">
        <Link className="editorial-breadcrumb" to="/company/newsroom">Newsroom <span aria-hidden="true">/</span> Analysis</Link>
        <div className="editorial-category">{article.tag}</div>
        <h1>{article.title}</h1>
        <p className="editorial-dek">{article.subtitle}</p>
        <div className="editorial-byline">
          <div><Link to="/team/sviatoslav-gladyshev">{article.author}</Link><span>{article.authorRole}</span></div>
          <div className="editorial-date"><time dateTime={article.createdAt}>{article.date}</time><span>{article.readTime}</span></div>
        </div>
      </header>
      <figure className="editorial-cover">
        <img src={article.heroImage} srcSet={article.heroSrcSet} sizes={article.heroSizes} alt={article.heroAlt} width={article.heroWidth} height={article.heroHeight} fetchPriority="high" />
        <figcaption>{article.heroCaption}{article.heroCredit && <span className="editorial-credit">Credit: {article.heroCredit}</span>}</figcaption>
      </figure>
      <div className="article-body editorial-body editorial-column" dangerouslySetInnerHTML={{ __html: article.content }} />
      <footer className="editorial-end editorial-column">
        <div className="editorial-author">
          <div className="editorial-overline">About the author</div>
          <h2><Link to="/team/sviatoslav-gladyshev">{article.author}</Link></h2>
          <p className="editorial-author-role">{article.authorRole}</p>
          <p>{article.authorBio}</p>
        </div>
        <aside className="editorial-related" aria-labelledby="previous-analysis-title">
          <div className="editorial-overline">{article.related.label || "Previous analysis"}</div>
          <h2 id="previous-analysis-title"><Link to={article.related.url}>{article.related.title} <span aria-hidden="true">→</span></Link></h2>
          <p>{article.related.description}</p>
        </aside>
        <div className="editorial-end-links"><Link to="/company/newsroom">All newsroom articles</Link><a href={article.sourceUrl} target="_blank" rel="noopener noreferrer">Read on X <span aria-hidden="true">↗</span></a><Link to="/ax#architecture">Explore Ateno’s technology <span aria-hidden="true">→</span></Link></div>
      </footer>
    </article>
  );
}
